// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { ellipsis } from "@awc/XDL/Utilities";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { css } from "styled-components";

interface XProductPartNumbersStyles {
    label: TypographyPresentationProps;
    value: TypographyPresentationProps;
}

const xProductPartNumbersStyles: XProductPartNumbersStyles = {
    label: {
        size: fontConfig.fontSize.small,
        weight: fontConfig.weight.medium,
        lineHeight: fontConfig.lineHeight.singleLineSmall,
        css: css`
            letter-spacing: 0;
            margin-right: 4px;
            flex-shrink: 0;
            display: inline-block;
            flex: 0 0 auto;
            padding-left: 0;
            &:after {
                content: ":";
            }
        `,
    },
    value: {
        weight: fontConfig.weight.regular,
        size: fontConfig.fontSize.small,
        lineHeight: fontConfig.lineHeight.singleLineSmall,
        ellipsis: true,
        color: "text",
        css: css`
            flex: 1 1 auto;
            letter-spacing: 0;
            min-width: 0;
            ${ellipsis(1)}
            white-space: normal;
            word-break: break-all;
        `,
    },
};

export default xProductPartNumbersStyles;
